module.exports = __webpack_public_path__ + "img/p2-21.c0396a80.png";